import { render, staticRenderFns } from "./RequestSetting.vue?vue&type=template&id=1b1c403f&"
import script from "./RequestSetting.vue?vue&type=script&lang=js&"
export * from "./RequestSetting.vue?vue&type=script&lang=js&"
import style0 from "./RequestSetting.vue?vue&type=style&index=0&id=1b1c403f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports